import React, { useState, useEffect  } from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import backlogo from '../../Assets/App_icon/back.png';
import excellogo from '../../Assets/App_icon/excel.png';


const ProductMaster = () => {
  
  const store = localStorage.getItem('store');
  const host_url = localStorage.getItem('host_url');

  const navigate = useNavigate();

  const [modalVisible, setModalVisible] = useState(false); 
  
  const [catlist, setCatlist] = useState([]);
  const [prdlist, setPrdlist] = useState([]);
  const [prdCustDetail, setPrdCustDetail] = useState([]);
  const [selectedPrdDetail, setSelectedPrdDetail] = useState([]);
  

  const handleBack = () => {
    navigate('../dashboard');
  };
  
  useEffect(() => {
      document.title = "Oorder Product Report ";
    }, []); // for Title Set

  // Escape key press handling
    useEffect(() => {
        const handleKeyPress = (event) => {
        if (event.key === "Escape") {
          // Close modal or navigate back if no modal is open
          if (modalVisible)  {
              setModalVisible(false);
          } else {
            handleBack();
          }
        }
        
      };

      document.addEventListener("keydown", handleKeyPress);
      return () => {
        document.removeEventListener("keydown", handleKeyPress);
      };
    }, [modalVisible]);
 

    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          const formData = new FormData();
          formData.append("type", "list");
          formData.append("store", store);
          formData.append("catlist", '');

          try {
            const response = await fetch(`${host_url}/category_mlist`, {
              method: 'POST',
              body: formData,
            });
            
            const data = await response.json();
            setCatlist(data);
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url]); // Categoty Fetch 

    useEffect(() => { 
      const fetchCatagoryList = async () => { 
          try {
            const response = await fetch(`${host_url}/stock_ord_prd`, {
              method: 'POST', 
              headers: {
                'Content-Type': 'application/json',
                'userid': localStorage.getItem('userid'),
              },
              body: JSON.stringify({
                type: 'list',
                store: store,
              }),
            });
            
            if (response.status === 401) {
              localStorage.clear();
              alert('Your account has been disabled.');
              window.location.href = "/";
              return;
            }

            const data = await response.json();
            console.log(data.order);
            setPrdCustDetail(data.order);
            setPrdlist(data.product);
          } catch (error) {
            console.error('Error fetching categories:', error);
          }
      }; 
     fetchCatagoryList(); 
    }, [host_url]); // Product Fetch

    const [prdNameFilter, setPrdNameFilter] = useState('');
    const [prdEnameFilter, setPrdEnameFilter] = useState('');
    const [catEnameFilter, setCatEnameFilter] = useState('');
    const [orderQtyFilter, setOrderQtyFilter] = useState('');
    const [stockFilter, setStockFilter] = useState('');
    const [stockAmtFilter, setStockAmtFilter] = useState('');

    const filteredPrdlist = prdlist.filter(prd =>
      prd.prd_name.toLowerCase().includes(prdNameFilter.toLowerCase()) &&
      prd.prd_Ename.toLowerCase().includes(prdEnameFilter.toLowerCase()) && 
      String(prd.pcat_id).toLowerCase().includes(catEnameFilter.toLowerCase()) && 
      (orderQtyFilter === "" ||  (orderQtyFilter === "Minus" && prd.total_order_qty < 0) || (orderQtyFilter === "Plus" && prd.total_order_qty > 0)) &&
      (stockFilter === "" ||  (stockFilter === "Minus" && prd.prd_stock < 0) || (stockFilter === "Plus" && prd.prd_stock > 0)) &&
      (stockAmtFilter === "" ||  (stockAmtFilter === "Minus" && prd.after_order_qty < 0) || (stockAmtFilter === "Plus" && prd.after_order_qty > 0))
    );

    const totalCount = filteredPrdlist.length;

    const handleSelectedPrd = (row) => {
      const filteredDetails = prdCustDetail.filter(detail => detail.prd_id === row.prd_id);
      setSelectedPrdDetail(filteredDetails);
      setModalVisible(true);
      
    };

    const exportToExcel = async () => {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Stock Report');

      // Define headers
        worksheet.columns = [
          { header: 'Category', key: 'Category', width: 20 },
          { header: 'G_Name', key: 'G_Name', width: 30 },
          { header: 'After_Order', key: 'After_Order', width: 15 },
          { header: 'Stock', key: 'Stock', width: 15 },
        ];

      // Add rows
        filteredPrdlist.forEach(item => {
          worksheet.addRow({
            Category: item.pcat_Ename,
            G_Name: item.prd_name,
            After_Order: item.total_order_qty,
            Stock: item.prd_stock,
          });
        });


      // Apply borders to all cells in the worksheet
        worksheet.eachRow((row, rowNumber) => {
          row.height = 35;
          row.alignment = {vertical: 'middle'};
          row.eachCell(cell => {
            cell.border = {
              top:    { style: 'dotted' },
              left:   { style: 'dotted' },
              bottom: { style: 'dotted' },
              right:  { style: 'dotted' },
            };
          });
        });

      // ✅ Right-align "After_Order" and "Stock" columns
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber === 1) return; // Skip header row

          // After_Order = column 3, Stock = column 4 (1-based indexing)
          row.getCell(3).alignment = { vertical: 'middle', horizontal: 'right' };
          row.getCell(4).alignment = { vertical: 'middle', horizontal: 'right' };
        });

      // Apply header styles
        worksheet.getRow(1).eachCell(cell => {
          cell.font = { bold: true };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFEFEFEF' }
          };
        });

      // Write to file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'StockReport.xlsx');
    };



  return (
    <div className="container">
          <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <div onClick={handleBack}>
                <img src={backlogo} alt="Back" className='system-icon'/>
              </div>
              <b style={{ margin: '10px', fontSize: '20px' }}>Order Product Report</b>
              <div >
                <div onClick={exportToExcel}>
                  <img src={excellogo} alt="Back" className='system-icon'/>
                </div>
              </div>
          </div> 
        
          <table className="table-bordered table-sm custom-hover">
            <thead>
              <tr >
                <th colSpan='2'>Category</th>
                <th colSpan='2'>E_Name</th>
                <th colSpan='2'>G_Name</th>
                <th>Order</th>
                <th>Stock</th>
                <th>After Order</th>
              </tr>
              <tr>
                <th colSpan='2'>
                  <select
                    className="search-input"
                    value={catEnameFilter}
                    onChange={(e) => setCatEnameFilter(e.target.value)}
                  >
                    <option value="">All Category</option>
                    {catlist.map((catlist) => (
                      catlist.pcat_count > 0 && (
                        <option key={catlist.pcat_Id} value={catlist.pcat_id}>
                          {catlist.pcat_Ename}
                        </option>
                      )
                    ))}
                  </select>
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={prdEnameFilter}
                    onChange={(e) => setPrdEnameFilter(e.target.value)}
                  />
                </th>
                <th colSpan='2'>
                  <input
                    type="text"
                    className="search-input"
                    value={prdNameFilter}
                    onChange={(e) => setPrdNameFilter(e.target.value)}
                  />
                </th>   
                <th>
                  <select
                    className="search-input"
                    value={orderQtyFilter}
                    onChange={(e) => setOrderQtyFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Minus">Minus</option>
                    <option value="Plus">Plus</option>
                  </select> 
                   
                </th>
                <th>
                  <select
                    className="search-input"
                    value={stockFilter}
                    onChange={(e) => setStockFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Minus">Minus</option>
                    <option value="Plus">Plus</option>
                  </select>  
                </th>
                <th>
                  <select
                    className="search-input"
                    value={stockAmtFilter}
                    onChange={(e) => setStockAmtFilter(e.target.value)}
                  >
                    <option value="">All Status</option>
                    <option value="Minus">Minus</option>
                    <option value="Plus">Plus</option>
                  </select> 
                </th>
              </tr>
            </thead>
            <tbody className="scrollable-body">
              {filteredPrdlist.map((row, index) => {
                  return (
                    <tr key={index} style={{ lineHeight: '10px', fontSize:'14px' }} onClick={() => handleSelectedPrd(row)}>
                      <td className="cell-left" colSpan="2"><span style={{ paddingLeft: '10px' }}>{row.pcat_Ename}</span></td>
                      <td className="cell-left" colSpan="2">{row.prd_Ename}</td>
                      <td className="cell-left" colSpan="2">{row.prd_name}</td>
                      <td className="cell-right" style={{ color: row.total_order_qty < 0 ? 'red' : 'inherit' }} >{row.total_order_qty == 0 ? '' : row. total_order_qty } </td>
                      <td className="cell-right" style={{ color: row.prd_stock < 0 ? 'red' : 'inherit' }} >{row.prd_stock == 0 ? '' : row.prd_stock } </td>
                      <td className="cell-right" style={{ color: row.after_order_qty < 0 ? 'red' : 'inherit' }} >{row.after_order_qty == 0 ? '' : row.after_order_qty } </td>
                    </tr>
                  );
              })}
            </tbody>
            <tfoot>
              <tr >
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}>{totalCount}</span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                <th className="cell-left" colSpan='2'><span style={{ paddingLeft: '10px' }}></span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}></span></th>
                <th className="cell-right"><span style={{ paddingRight: '15px' }}></span></th>
                <th className="cell-right"><span style={{ paddingRight: '5px' }}></span></th>
              </tr>
            </tfoot>
          </table>


          {/* Modal for Area Detail */}   
            <Modal isOpen={modalVisible} toggle={() => setModalVisible(!modalVisible)} className="detailmodal-lg" backdrop="static" keyboard={false}>
              <ModalBody style={{ backgroundColor: '#e8fadb'}}>
                <h5 >Order Detail</h5>  
                    
                    <table style={{ backgroundColor: '#e8fadb', border: '0px', width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ padding: '2px' }} >Id</th>
                          <th style={{ padding: '2px' }} >Name</th>
                          <th style={{ padding: '2px' }} >Area</th>
                          <th style={{ padding: '2px', paddingRight: '10px', }} >Qty</th>
                        </tr>
                      </thead>
                      <tbody className="scrollable-body">
                        {selectedPrdDetail.map((row, index) => {
                            return (
                              <tr key={index} >
                                <td className="cell-left" style={{ padding: '2px', paddingLeft: '5px', fontSize: '14px' }}>{row.cust_id}</td>
                                <td className="cell-left" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.cust_name}</td>
                                <td className="cell-left" style={{ padding: '2px', paddingLeft: '10px', fontSize: '14px' }} >{row.area_name}</td>
                                <td className="cell-right" style={{ padding: '2px', paddingRight: '10px', fontSize: '14px' }} >{row.order_qty}</td>
                              </tr>
                            );
                        })}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th colSpan='2' className="cell-left"style={{ padding: '2px' }} >
                            <Button color="primary" style={{ padding: '2px', margin: '2px' }} onClick={() => setModalVisible(false)}>
                              Close
                            </Button>
                          </th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} ></th>
                          <th className="cell-right" style={{ padding: '2px', paddingRight: '10px' }} >{selectedPrdDetail?.reduce((sum, order) => sum + parseFloat(order.order_qty || 0), 0).toFixed(3)}</th>
                        </tr> 
                      </tfoot>
                    </table>
                  
              </ModalBody>
            </Modal>
           

        
    </div>
  );
};

export default ProductMaster;
